import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Situacion } from '../model/situacion';


@Injectable({
  providedIn: 'root'
})
export class SituacionesService {

  private PATH = '/Situaciones';

  constructor(
    private http: HttpClient
  ) { }

  public getSituaciones(stateId?: number): Observable<Situacion[]> {
    const stateIdQueryParam = !stateId ? '' : `/${stateId}`;
    return this.http.get(`${environment.API_BASE}${this.PATH}${stateIdQueryParam}`)
      .pipe(map((situaciones: Situacion[]) => situaciones.map((situacion: Situacion) => Situacion.toModel(JSON.stringify(situacion)))));
  }

}
